module.exports = __webpack_public_path__ + "img/full7-min.22de72d6.png";